import * as events from '../base/constant';
import { isActionPrevent } from '../base/util';
import { CheckBoxFilterBase } from '../common/checkbox-filter-base';
/**
 * @hidden
 * `CheckBoxFilter` module is used to handle filtering action.
 */
var CheckBoxFilter = /** @class */ (function () {
    /**
     * Constructor for checkbox filtering module
     * @hidden
     */
    function CheckBoxFilter(parent, filterSettings, serviceLocator) {
        this.parent = parent;
        this.isresetFocus = true;
        this.checkBoxBase = new CheckBoxFilterBase(parent);
        this.addEventListener();
    }
    /**
     * To destroy the check box filter.
     * @return {void}
     * @hidden
     */
    CheckBoxFilter.prototype.destroy = function () {
        this.removeEventListener();
        this.checkBoxBase.closeDialog();
    };
    CheckBoxFilter.prototype.openDialog = function (options) {
        this.checkBoxBase.openDialog(options);
        this.parent.log('column_type_missing', { column: options.column });
    };
    CheckBoxFilter.prototype.closeDialog = function () {
        this.removeEventListener();
        this.checkBoxBase.closeDialog();
        if (this.isresetFocus) {
            this.parent.notify(events.restoreFocus, {});
        }
    };
    /**
     * For internal use only - Get the module name.
     * @private
     */
    CheckBoxFilter.prototype.getModuleName = function () {
        return 'checkboxFilter';
    };
    CheckBoxFilter.prototype.actionBegin = function (args) {
        this.parent.trigger(events.actionBegin, args);
    };
    CheckBoxFilter.prototype.actionComplete = function (args) {
        this.parent.trigger(events.actionComplete, args);
    };
    CheckBoxFilter.prototype.actionPrevent = function (args) {
        if (isActionPrevent(this.parent)) {
            this.parent.notify(events.preventBatch, args);
            args.cancel = true;
        }
    };
    CheckBoxFilter.prototype.addEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.cBoxFltrBegin, this.actionBegin, this);
        this.parent.on(events.cBoxFltrComplete, this.actionComplete, this);
        this.parent.on(events.fltrPrevent, this.actionPrevent, this);
    };
    CheckBoxFilter.prototype.removeEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.cBoxFltrBegin, this.actionBegin);
        this.parent.off(events.cBoxFltrComplete, this.actionComplete);
        this.parent.off(events.fltrPrevent, this.actionPrevent);
    };
    return CheckBoxFilter;
}());
export { CheckBoxFilter };
